import axios, { AxiosResponse } from 'axios'
import { FaturaView, PageResponseFaturaList } from '../../faturas-list/core/_models'

const API_URL = process.env.REACT_APP_API_URL
const FINANCEIRO_URL = `${API_URL}/financeiro`
const FINANCEIRO_FATURA_URL = `${FINANCEIRO_URL}/fatura`
const FINANCEIRO_FATURA_EMPRESA_URL = `${FINANCEIRO_FATURA_URL}/empresa`

/**
 * Busca faturas de cliente
 * @param idEmpresa ID da Empresa
 * @param query string
 * @returns PageResponseFaturaList
 */
export const getFaturasByEmpresa = (
  idEmpresa: number,
  query: string
): Promise<PageResponseFaturaList> => {
  return axios
    .get(`${FINANCEIRO_FATURA_EMPRESA_URL}/${idEmpresa}?${query}`)
    .then((resp: AxiosResponse<PageResponseFaturaList>) => resp.data)
}

/**
 * Busca uma fatura de um cliente
 * @param idEmpresa ID da Empresa
 * @param idFatura  ID da Fatura
 * @returns FaturaView
 */
export const getFaturaByEmpresa = (idEmpresa: number, idFatura: number): Promise<FaturaView> => {
  return axios
    .get(`${FINANCEIRO_FATURA_EMPRESA_URL}/${idEmpresa}/${idFatura}`)
    .then((resp: AxiosResponse<FaturaView>) => resp.data)
}
